import React, { useState } from 'react';
import { API_BASE_LOCAL_URL } from '../config';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false); // Added for UX

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_LOCAL_URL}/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('token', data.jwt || data.token);
        localStorage.setItem('username', data.username);
        localStorage.setItem('role', data.role);
        window.location.href = '/AdminDashboard';
      } else {
        setError(data.message || 'Invalid credentials. Please try again.');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('Server connection failed. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      <div className="card shadow-lg border-0" style={{ maxWidth: '450px', width: '100%', borderRadius: '15px' }}>
        <div className="card-body p-5">
          {/* Header Section */}
          <div className="text-center mb-4">
            <div className="bg-success text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '60px', height: '60px' }}>
              <i className="bi bi-shield-lock-fill fs-3"></i> 
            </div>
            <h3 className="fw-bold">Admin Portal</h3>
            <p className="text-muted small">Please enter your credentials to continue</p>
          </div>

          <form onSubmit={handleLogin}>
            {/* Error Message */}
            {error && (
              <div className="alert alert-danger py-2 small d-flex align-items-center" role="alert">
                <i className="bi bi-exclamation-triangle-fill me-2"></i>
                {error}
              </div>
            )}

            {/* Email Field */}
            <div className="mb-3">
              <label className="form-label small fw-semibold text-secondary">Email Address</label>
              <input
                type="email"
                className="form-control form-control-lg bg-light border-0 shadow-sm"
                placeholder="admin@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{ fontSize: '0.95rem' }}
              />
            </div>

            {/* Password Field */}
            <div className="mb-4">
              <label className="form-label small fw-semibold text-secondary">Password</label>
              <div className="input-group shadow-sm">
                <input
                  type={showPassword ? 'text' : 'password'}
                  className="form-control form-control-lg bg-light border-0"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  style={{ fontSize: '0.95rem' }}
                />
                <button
                  type="button"
                  className="btn btn-light border-0 text-muted px-3"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex={-1}
                >
                  {showPassword ? "Hide" : "Show"}
                </button>
              </div>
            </div>

            {/* Submit Button */}
            <button 
              type="submit" 
              className="btn btn-success btn-lg w-100 fw-bold shadow-sm"
              disabled={loading}
              style={{ transition: 'all 0.3s' }}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Authenticating...
                </>
              ) : (
                'Sign In'
              )}
            </button>
          </form>
        </div>
        <div className="card-footer bg-white border-0 text-center pb-4">
          <small className="text-muted">&copy; 2026 Your Company Admin</small>
        </div>
      </div>
    </div>
  );
}